module.exports = __webpack_public_path__ + "images/ui-bg_glass_65_ffffff_1x400.png";